import { system } from '@styled-system/core';
var config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
export var flexbox = system(config);
export default flexbox;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@styled-system/flexbox/dist/index.esm.js
// module id = 746
// module chunks = 0